import { connect } from 'react-redux'
import { compose, withHandlers, withProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import withNormalizeValue from 'components/common/hoc/withNormalizeValue'
import reduxForm from 'components/common/hoc/withFormErrorFocus'
import BOTFleetServicesContactUsForm from './BOTFleetServicesContactUsForm'
import formViewModel from '../viewModel'
import { submitFormAction } from '../actions'
import { fleetValidator } from '../validate'
import {
  FLEET_CONTACT_US_FORM,
  FUTURE_CONTACT,
  COMMENTS_FIELD,
  SUBJECT_FIELD,
  FLEET_DEFAULTS
} from '../constants'
import { isFleetServicePage } from '../helpers'

const mapStateToProps = state => ({
  isFleetServicesPage: isFleetServicePage(state)
})

const withFormProps = withProps({
  formViewModel
})

const withFormHandlers = withHandlers({
  onSubmit: ({ submitFormAction }) => values => {
    const valuesUpdated = {
      ...values,
      [FUTURE_CONTACT]: FLEET_DEFAULTS.FUTURE_CONTACT,
      [COMMENTS_FIELD]: FLEET_DEFAULTS.COMMENTS_FIELD,
      [SUBJECT_FIELD]: FLEET_DEFAULTS.SUBJECT_FIELD
    }

    submitFormAction(valuesUpdated)
  }
})

export default compose(
  withType({ type: 'BOTFleetServicesContactUsForm' }),
  connect(mapStateToProps, { submitFormAction }),
  withFormHandlers,
  withNormalizeValue,
  withFormProps,
  reduxForm({ form: FLEET_CONTACT_US_FORM, validate: fleetValidator })
)(BOTFleetServicesContactUsForm)
